import Definitions from './Definitions';

const QuestionnaireDefs = {
    options: null,
    init: (options) => {
        QuestionnaireDefs.options = options;
    },
    mergeConfigs: (options) => {
        const merge = (incomingConfig) => {
            return new Promise((resolve) => {
                let output = null;
                if (
                    QuestionnaireDefs &&
                    QuestionnaireDefs.options &&
                    QuestionnaireDefs.options.definitionsDirURL
                ) {
                    Definitions.load(
                        QuestionnaireDefs.options.definitionsDirURL,
                        incomingConfig.questionnaireName,
                        (result) => {
                            if (result) {
                                output = {
                                    ...result,
                                    ...incomingConfig
                                };
                            } else {
                                output = incomingConfig;
                            }
                            resolve(Definitions.postProcess(output));
                        },
                        () => {
                            resolve(Definitions.postProcess(incomingConfig));
                        }
                    );
                } else {
                    resolve(Definitions.postProcess(incomingConfig));
                }
            });
        };

        if (Array.isArray(options.questionnaireOptions)) {
            const promises = [];
            options.questionnaireOptions.forEach((config) => {
                if (config.value) {
                    promises.push(merge(config.value));
                }
            });
            Promise.all(promises).then((responses) => {
                responses.forEach((r, i) => {
                    options.questionnaireOptions[i].value = r;
                });
                options.onSuccess(options.questionnaireOptions);
            });
        } else {
            merge(options.questionnaireOptions).then((merged) => {
                if (merged) {
                    options.onSuccess(merged);
                }
            });
        }
    }
};

export default QuestionnaireDefs;
